import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { translations } from './content/translations.js';

const initialLng =
  typeof window !== 'undefined' && window.location.pathname.startsWith('/el')
    ? 'gr'
    : 'en';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: translations.en },
      gr: { translation: translations.gr },
    },
    lng: initialLng,
    fallbackLng: 'en',
    supportedLngs: ['en', 'gr'],
    interpolation: { escapeValue: false },
  });

export default i18n;
